/**
 * Mock goals service.
 * Mirrors the real goals.service.js API with in-memory data.
 */
import { MOCK_GOALS, MOCK_COMPLETED_GOALS } from '../../data/mock/mock-accountability.data';
import { mockDelay, mockLog, mockId } from './mock-delay';

// In-memory state
let activeGoals = [...MOCK_GOALS];
let completedGoals = [...MOCK_COMPLETED_GOALS];

export const createGoal = async (userId, goalData) => {
  mockLog('GoalsService', 'createGoal', goalData.title);
  await mockDelay();
  const goal = {
    id: `mock_goal_${mockId()}`,
    title: goalData.title || '',
    category: goalData.category || 'custom',
    targetValue: goalData.targetValue ?? null,
    currentValue: goalData.currentValue ?? 0,
    unit: goalData.unit || '',
    deadline: goalData.deadline || null,
    status: 'active',
    createdAt: new Date().toISOString(),
    completedAt: null,
  };
  activeGoals = [goal, ...activeGoals];
  return goal;
};

export const getGoals = async (userId, status = 'active') => {
  mockLog('GoalsService', 'getGoals', { userId, status });
  await mockDelay();
  if (status === 'completed') return [...completedGoals];
  return activeGoals.filter((g) => g.status === status);
};

export const updateGoalProgress = async (userId, goalId, currentValue) => {
  mockLog('GoalsService', 'updateGoalProgress', { goalId, currentValue });
  await mockDelay();
  const idx = activeGoals.findIndex((g) => g.id === goalId);
  if (idx !== -1) {
    activeGoals[idx] = { ...activeGoals[idx], currentValue };
    return activeGoals[idx];
  }
  return null;
};

export const completeGoal = async (userId, goalId) => {
  mockLog('GoalsService', 'completeGoal', goalId);
  await mockDelay();
  const idx = activeGoals.findIndex((g) => g.id === goalId);
  if (idx !== -1) {
    const completed = { ...activeGoals[idx], status: 'completed', completedAt: new Date().toISOString() };
    activeGoals = activeGoals.filter((g) => g.id !== goalId);
    completedGoals = [completed, ...completedGoals];
    return completed;
  }
  return null;
};

export const abandonGoal = async (userId, goalId) => {
  mockLog('GoalsService', 'abandonGoal', goalId);
  await mockDelay();
  const idx = activeGoals.findIndex((g) => g.id === goalId);
  if (idx !== -1) {
    activeGoals[idx] = { ...activeGoals[idx], status: 'abandoned' };
    return activeGoals[idx];
  }
  return null;
};

export const deleteGoal = async (userId, goalId) => {
  mockLog('GoalsService', 'deleteGoal', goalId);
  await mockDelay();
  activeGoals = activeGoals.filter((g) => g.id !== goalId);
  completedGoals = completedGoals.filter((g) => g.id !== goalId);
  return goalId;
};
